import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { NULL } from 'sass';
import { MaterialModule } from '../../../material.module';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';
import { CharitiesService } from '../charities/services/charities.service';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { SubmissionsapiService } from './submissionsapi.service';
import JSZip from 'jszip';
import saveAs from 'file-saver';
import * as vkbeautify from 'vkbeautify';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { AceModule } from 'ngx-ace-wrapper';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-eclipse';
import 'ace-builds/src-noconflict/ext-language_tools';
import { LocalStorageService } from '../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import Swal from 'sweetalert2';
import { FinalAccountsapiService } from '../final-accounts/final-accountsapi.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { MobileNumberDirective } from '../../../Directives/mobile-number.directive';
import moment from 'moment';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { InputRestrictionDirective } from '../../../Directives/input-restriction.directive';

@Component({
  selector: 'app-submissions',
  imports: [MaterialModule, TablerIconsModule, CommonModule, ReactiveFormsModule, MobileNumberDirective, PdfJsViewerModule, AceModule, InputRestrictionDirective],
  templateUrl: './submissions.component.html',
  providers: [DatePipe],
  styleUrl: './submissions.component.scss'
})
export class SubmissionsComponent implements OnInit {
  @ViewChild('xmlViewerTemplate') xmlViewerTemplate!: TemplateRef<any>;
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
  @ViewChild('template1', { static: false }) template1!: ElementRef;
  submissions_card: boolean = true;
  filing_details: boolean = false;
  submissionFBIpage: boolean = false;
  inputType: string = 'password';
  CharityDetails: CharityDetailsModal[] = [];
  SubmissionForm: FormGroup
  PresenterEmailAddressDoubleclickCount: any;
  PresenterIDDoubleclickCount: any;
  PresenterAuthenticationCodeDoubleclickCount: any;
  packageReference: any;
  XML_Qualifier: any
  FBI_XMLToUpload: any;
  FBI_XMLData: any;
  xml_result: any;
  recordStatus: any;
  submissionNumber: string | null;
  TransactionId: string | null;
  FbiStatus: string;
  xmlDataRequest: string;
  FBI_StartTimeStamp: any;
  FBI_EndTimeStamp: any;
  CharityName: any;
  ShowFBI: boolean;
  SubmissionStatus: string | null;
  Qualifier: string | null;
  CompanyHouseSubmissionStatus: any = 'Not Submitted';
  SubmissionId: any;
  LoginUserName: any;
  SubmissionDetails: any = [];
  AccountingPeriod: any = [];
  SwalHTML: any;
  ShowSpinner: any = false;
  ShowSpinnerNote: any = false;
  periodId: any;
  userId: any;
  centralUserId: any;
  charityId: any;
  inputType1: string = 'password';
  pdfFile: string;
  xmlData: any;
  charityName: string;
  errorType: any;
  errorLocation: any;
  errorText: any;
  ccSubmittedBy: any = '';
  ccSubmittedDate: any = null;
  ccSubmittedRef: any = '';
  //xmlDataRequest: null;
  mode = 'text';
  theme = 'eclipse';
  editorOptions = {
    fontSize: '14px',
    showPrintMargin: false,
    readOnly: true,        // for viewing only
    showFoldWidgets: false, // enable folding
    foldStyle: 'markbegin',
  };
  errorNumber: any;
  exportForm: FormGroup
  BalanceSheetStatus: any;
  TrailBalanceStatus: any;
  SOFAStatus: any;
  TrusteeAnnualReportStatus: any;
  AuditorStatus: any;
  IndependentExaminationStatus: any;
  StatementStatus: any;
  ReceiptsStatus: any;
  StatementofTrusteesResponsibility: any
  accounting_Method: any
  report_Type: any
  filteredAccounts: any;
  filteredAccounts_Recipts: any;
  progress: number = 0;
  notesArray: any
  notecompleted: boolean = true
  Base64orHTML: any;
  ShowSpinnerTwo: any = false;
  selectAll: boolean = false;
  AllAcountsInfo: CharityAccountArInformation;
  PeriodDetils: any;
  ritreavedPeriodDetails: CharityAccountArInformation[] = [];
  currentperiod: string = '';
  Charity_Type: any;
  AP_endDate: string | null;
  submissionType: any;
  ShowSpinner3: any = false;
  ReportType: any;
  Account_Type: string | null;
  apFinalised: boolean = false;
  isDisabled: boolean = true;
  Jurisdiction_Charity: string | null;

  ngOnInit() {
    debugger
    this.dataShareService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
    })
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.submittedaslistchange()
    this.accounting_Method = localStorage.getItem('accounting_Method') != '' ? localStorage.getItem('accounting_Method') : ''
    // this.sharedService.setFinalStatus('Completed')
    this.sharedService.FY_Year$.subscribe(value => {
      let date = value.split('*')[0];
      this.AccountingPeriod = value.split('*')[1];
    });
    this.sharedService.ReportTypeMethod$.subscribe(value => {
      this.ReportType = value
    });
    this.Getbasicinformation();
    this.APEndDate()
    this.CreateSubmissionForm();

    this.PresenterEmailAddressDoubleclickCount = 0;
    this.PresenterIDDoubleclickCount = 0;
    this.PresenterAuthenticationCodeDoubleclickCount = 0;
    // this.GetSubmissionCredentials();
    this.GetSubmissionDetails();
    this.GetFinalAccountsInfo()
    this.CreateCheckboxform()


    this.exportForm.valueChanges.subscribe(() => {
      const filteredControls = this.getFilteredControls();
      const allSelected = filteredControls.every(([_, control]) => control.value === true);
      this.selectAll = allSelected;
    });
  }

  constructor(public dialog: MatDialog, private datepipe: DatePipe, private sharedService: CharityDataShareServiceService, private apiservice: FinalAccountsapiService, private dataShareService: CharityDataShareServiceService, private _UsermanagementService: UsermanagementService, private lsService: LocalStorageService, public Charities_Service: CharitiesService, private Submissionsapiservice: SubmissionsapiService, private router: Router, private msgService: MessageServiceService) {
    this.GetUserAccess()
    this.Getcharitydetails()
    this.Account_Type = localStorage.getItem('account_Type')
  }

  APEndDate() {
    debugger
    let str: any = localStorage.getItem('financial_Year') != '' ? localStorage.getItem('financial_Year') : '';
    this.AP_endDate = str.split('To')[1].split('*')[0];
  }
  UserRoleAccess: RolesModel;
  GetUserAccess() {
    debugger
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }
  submissions: boolean = false;
  GetSubmissionDetails() {
    debugger
    if (localStorage.getItem('currentPeriod') != null && localStorage.getItem('currentPeriod') != '') {
      this.Submissionsapiservice.GetSubmissionDetails(localStorage.getItem('currentPeriod')).subscribe(data => {
        debugger
        if (data != null) {
          if (data.length > 0) {
            this.SubmissionDetails = data;
            if (this.SubmissionDetails[0]?.companyHouseSubmissionStatus == 'pending' || this.SubmissionDetails[0]?.companyHouseSubmissionStatus?.toLowerCase() == 'accept' || this.SubmissionDetails[0]?.companyHouseSubmissionStatus?.toLowerCase() == 'reject') {
              if (this.SubmissionDetails[0]?.isActive == true) {
                this.isDisabled = false;
              } else {
                this.isDisabled = true;
              }
              if (this.SubmissionDetails[0]?.companyHouseSubmissionStatus?.toLowerCase() == 'accept') {
                this.CompanyHouseSubmissionStatus = 'Accepted';
              }
              else if (this.SubmissionDetails[0]?.companyHouseSubmissionStatus?.toLowerCase() == 'reject') {
                this.CompanyHouseSubmissionStatus = 'Rejected';
              }
              else {
                this.CompanyHouseSubmissionStatus = 'Pending CoHse response';
              }
            } else if (this.SubmissionDetails[0].companyHouseSubmissionStatus != null) {
              this.CompanyHouseSubmissionStatus = this.SubmissionDetails[0].companyHouseSubmissionStatus
            }
            this.FBI_StartTimeStamp = this.SubmissionDetails[0].fbiStartTimeStamp
            this.submissionNumber = this.SubmissionDetails[0].submissionNumber
            this.LoginUserName = this.SubmissionDetails[0].contactName   //here username coming as contactname
            this.submissionType = this.SubmissionDetails[0].submissionType
            this.SubmissionStatus = this.SubmissionDetails[0].submissionstatus
          }
        }
        else {
          this.submissions = false;
        }
      })
    }
  }
  toggleAll(event: MatCheckboxChange): void {
    const isChecked = event.checked;
    const filteredControls = this.getFilteredControls();

    filteredControls.forEach(([_, control]) => {
      control.setValue(isChecked);
    });
  }

  openPreview(template: any) {
    let dialogRef = this.dialog.open(template, {
      width: '50%', maxWidth: '100%'
    });
  }

  closeModalPreview() {
    this.dialog.closeAll();
  }
  retrieveCharityCumission(Message: any) {
    debugger
    this.periodId = localStorage.getItem('currentPeriod')
    this.userId = localStorage.getItem('userID')
    this.centralUserId = localStorage.getItem('CentralUserId')
    this.charityId = localStorage.getItem('currentCharityID')
    this.ritreavedPeriodDetails = []
    this.ShowSpinner = true
    this.Charities_Service.CharityAccountArInformation(this.CharityDetails[0]?.charity_Registration_Number, 0, this.periodId, this.centralUserId, this.userId, this.currentperiod).subscribe(response1 => {
      debugger
      if (Message == false) {
        const message = 'Submission Status has been updated successfully '
        this.msgService.showToastMessage('success', message)
      }
      if (response1.length > 0) {
        this.ritreavedPeriodDetails = response1
        this.ccSubmittedDate = this.ritreavedPeriodDetails[0].date_Received ? this.ritreavedPeriodDetails[0].date_Received?.split('T')[0] : '-'
        this.ShowSpinner = false
      } else {
        this.ccSubmittedDate = '-'
        this.ShowSpinner = false
      }
    });

  }
  toggleInputType(value: any): void {
    debugger
    if (value == 'CAC') {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    }
    if (value == 'PAC') {
      this.inputType1 = this.inputType1 === 'password' ? 'text' : 'password';
    }
  }
  Message: boolean = false
  getBasicInfornation() {
    debugger
    var PeriodID = localStorage.getItem('currentPeriod') == '' ? 0 : localStorage.getItem('currentPeriod')
    var CharityID = localStorage.getItem('currentCharityID')
    this.Charities_Service.Getbasicinfo(CharityID, PeriodID).subscribe((data: any) => {
      const formatShortDate = (dateStr: string): string => {
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }).format(date);
      };
      this.PeriodDetils = data
      this.currentperiod = `${this.PeriodDetils[0]?.current_AP_Start_Date} To ${this.PeriodDetils[0]?.current_AP_End_Date}*${this.PeriodDetils[0]?.financial_Year}`;
      this.Message = true
      this.retrieveCharityCumission(this.Message);
    })
  }

  Getcharitydetails() {
    debugger
    let charityID = localStorage.getItem("CharityIdforSubmission")
    if (charityID) {
      this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
        debugger
        this.CharityDetails = data
        this.Charity_Type = this.CharityDetails[0]?.charity_Type
        this.Jurisdiction_Charity = this.CharityDetails[0]?.jurisdiction_Charity
        this.getBasicInfornation()
      })
    }
  }
  SubmitToCC() {
    debugger
    if (this.Jurisdiction_Charity != "scotland") {
      var url = 'https://my-charity-account.charitycommission.gov.uk/'
      window.open(url, '_blank');
    }
    else {
      var url = 'https://oscradb2c.b2clogin.com/oscradb2c.onmicrosoft.com/b2c_1_signin/oauth2/v2.0/authorize?client_id=79b70de1-65af-4e13-84ef-5abfdd364d23&scope=openid%20profile%20offline_access&redirect_uri=https%3A%2F%2Foscronline.oscr.org.uk&client-request-id=85d36008-8920-4a83-bcf3-ce3c0ffd9f34&response_mode=fragment&response_type=code&x-client-SKU=msal.js.browser&x-client-VER=2.39.0&client_info=1&code_challenge=DBbgHVIc5tqGBIlIsea94a6LndfAqChiyBE2YkPrsPA&code_challenge_method=S256&nonce=837ded2b-d0eb-4c62-8776-9c3bdb3020b0&state=eyJpZCI6ImQ2MzkxM2FmLTI3YTItNDE3Ni05ZGQ5LWYxOTVhZjkzMThmNCIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3D'
      window.open(url, '_blank');
    }
  }
  SubmitToCH() {
    debugger
    this.submissions_card = false;
    this.filing_details = true;
    this.SubmissionForm.reset();
    this.CreateSubmissionForm();
    this.SubmissionForm.controls['RegistrationNumber'].setValue(this.CharityDetails[0].charity_Registration_Number)
    this.SubmissionForm.controls['RegistrationNumber'].disable();
    this.GetSubmissionCredentials();

  }
  Backtosubmissionscard() {
    this.submissions_card = true;
    this.filing_details = false;
  }
  CreateSubmissionForm() {
    this.SubmissionForm = new FormGroup({
      RegistrationNumber: new FormControl('', Validators.required),
      CompanyAuthenticationCode: new UntypedFormControl(null, { validators: Validators.compose([Validators.required, Validators.maxLength(6)]) }),
      Submittedas: new FormControl('Company', Validators.required),
      PresenterContactName: new FormControl(''),
      PresenterID: new FormControl('', Validators.required),
      PresenterAuthenticationCode: new FormControl('', Validators.required),
      PresenterEmailAddress: new FormControl('', { validators: Validators.compose([Validators.required, Validators.compose([Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/)])]), updateOn: 'blur' }),
      PresenterContactNumber: new FormControl(null),
      SubmissionType: new FormControl({ value: 'Live Submission', disabled: true }, Validators.required),//Live
      SaveCredentials: new FormControl(false),
    })
  }
  submitedlist: any = ['Company']
  submittedaslistchange() {
    this.Charities_Service.getPresenterInfo(localStorage.getItem('CentralUserId')).subscribe((data: any) => {
      if (data.entity != null) {
        this.submitedlist = ['Company', 'Agent']
      }
      else {
        this.submitedlist = ['Company']
      }
    })
  }
  submittedasChange(event: any) {
    debugger
    if (event.value == 'Agent') {
      this.Charities_Service.getPresenterInfo(localStorage.getItem('CentralUserId')).subscribe((data: any) => {
        if (data.entity != null) {
          var fullName = data.entity[0].foreName + " " + data.entity[0].surName
          this.SubmissionForm.get('PresenterContactName')?.setValue(fullName);
          this.SubmissionForm.get('PresenterID')?.setValue(data.entity[0].presenterID);
          this.SubmissionForm.get('PresenterAuthenticationCode')?.setValue(data.entity[0].presenterAuthenticationCode);
          this.SubmissionForm.get('PresenterEmailAddress')?.setValue(data.entity[0].emailAddress);
          this.SubmissionForm.get('PresenterContactNumber')?.setValue(data.entity[0].telephone);

          this.SubmissionForm.get('PresenterContactName')?.disable();
          this.SubmissionForm.get('PresenterID')?.disable();
          this.SubmissionForm.get('PresenterAuthenticationCode')?.disable();
          this.SubmissionForm.get('PresenterEmailAddress')?.disable();
          this.SubmissionForm.get('PresenterContactNumber')?.disable();
        }
      })
    }
    else {
      this.SubmissionForm.get('PresenterContactName')?.setValue(null);
      this.SubmissionForm.get('PresenterID')?.setValue(null);
      this.SubmissionForm.get('PresenterAuthenticationCode')?.setValue(null);
      this.SubmissionForm.get('PresenterEmailAddress')?.setValue(null);
      this.SubmissionForm.get('PresenterContactNumber')?.setValue(null);

      this.SubmissionForm.get('PresenterContactName')?.enable();
      this.SubmissionForm.get('PresenterID')?.enable();
      this.SubmissionForm.get('PresenterAuthenticationCode')?.enable();
      this.SubmissionForm.get('PresenterEmailAddress')?.enable();
      this.SubmissionForm.get('PresenterContactNumber')?.enable();
    }
  }
  BacktoSubmissions() {
    debugger
    this.submissionFBIpage = false
    this.filing_details = false
    this.submissions_card = true;
  }
  GetSubmissionStatus() {
    debugger
    this.ShowSpinner = true;
    const formData: FormData = new FormData();
    formData.append('SubmissionType', this.SubmissionDetails[0]?.submissionType);
    formData.append('PresenterID', this.SubmissionDetails[0]?.presenterID); //66663005000
    formData.append('PresenterAuthenticationCode', this.SubmissionDetails[0]?.presenterAuthenticationCode); //'8STFBL7WRZ6'
    formData.append('EmailAddress', this.SubmissionDetails[0]?.emailAddress); //'bharat@andica.com'
    formData.append('submissionNumber', this.SubmissionDetails[0]?.submissionNumber);
    formData.append('APPeriodId', this.SubmissionDetails[0]?.apPeriodId);
    this.Submissionsapiservice.GetSubmissionStatus(formData).subscribe(data => {
      debugger
      const message = 'Submission Status has been updated successfully '
      this.msgService.showToastMessage('success', message)
      this.ShowSpinner = false;
      this.GetSubmissionDetails()
    })
  }
  disableNaviagtion() {
    document.body.classList.add('disable')
  }
  enableNavigation() {
    document.body.classList.remove('disable')
  }

  SubmissionToCompanyHouse() {
    debugger
    this.SubmissionForm.markAllAsTouched();
    if (this.SubmissionForm.invalid) {
      return;
    }

    if (this.PresenterIDDoubleclickCount > 2 && this.PresenterAuthenticationCodeDoubleclickCount > 2 && this.PresenterEmailAddressDoubleclickCount > 2) {
      this.SubmissionForm.controls['SubmissionType'].setValue('Test');
      this.packageReference = '0012'

      this.SwalHTML = '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">This is a test submission.</h5><p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Information submitted will NOT be stored by the Companies House.<br> Select OK to continue submission.</p>';
    }
    else {
      this.SubmissionForm.controls['SubmissionType'].setValue('Live');
      this.packageReference = '4090'
      this.SwalHTML = '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">This is a Live submission to Companies House</h5><p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Once submission is completed you cannot amend or resubmit the data using the software.<br> Select OK to continue submission.</p>';
      // this.SwalHTML = 'This is a Live submission to Companies House, once submission is completed you cannot amend or resubmit the data using the software.<br> Select OK to continue submission.';
    }

    Swal.fire({
      html: this.SwalHTML,
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: "OK",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        debugger
        this.disableNaviagtion()
        this.ShowSpinner = true;
        this.XML_Qualifier = '1'
        const formData: FormData = new FormData();
        formData.append('CompanyRegistrationNumber', this.SubmissionForm.controls['RegistrationNumber'].value);
        formData.append('PresenterID', this.SubmissionForm.controls['PresenterID'].value); //66663005000
        formData.append('PresenterAuthenticationCode', this.SubmissionForm.controls['PresenterAuthenticationCode'].value); //'8STFBL7WRZ6'
        formData.append('EmailAddress', this.SubmissionForm.controls['PresenterEmailAddress'].value); //'bharat@andica.com'
        formData.append('CompanyAuthenticationCode', this.SubmissionForm.controls['CompanyAuthenticationCode'].value);//'444444'
        formData.append('Submitted_As', this.SubmissionForm.controls['Submittedas'].value);  //'Company'
        formData.append('SubmissionType', this.SubmissionForm.controls['SubmissionType'].value);
        formData.append('submissionNumber', '123456');
        formData.append('XML_Qualifier', this.XML_Qualifier);
        formData.append('ProductName', 'Andica Charity Accounts');
        formData.append('CompanyName', this.CharityDetails[0].charity_Name);
        formData.append('jurisdiction_Charity', this.CharityDetails[0].jurisdiction_Charity);
        formData.append('ReportType', this.ReportType);
        formData.append('APPeriodCoveredTo', '01/07/2024'); // date as string
        formData.append('ContactName', this.SubmissionForm.controls['PresenterContactName'].value);
        formData.append('ContactNumber', this.SubmissionForm.controls['PresenterContactNumber'].value);
        formData.append('CharityReferenceNumber', this.CharityDetails[0].company_Reference_Number);
        formData.append('SaveCredentials', this.SubmissionForm.controls['SaveCredentials'].value);
        formData.append('CharityId', this.CharityDetails[0].charityID);
        formData.append('Central_UserId', this.centralUserId);

        //For getting selected pages/modules only for submission.
        if (this.notecompleted) {
          this.exportForm.controls["notes"].disable()
          this.exportForm.controls["notes"].setValue(false);
        } else {
          this.exportForm.controls["notes"].enable()
          this.exportForm.controls["notes"].setValue(true);
        }
        const filteredControls = this.getFilteredControls();
        filteredControls.forEach(([_, control]) => {
          control.setValue(true);
        });
        this.exportForm.controls["is_ForSubmissions"].setValue(true);
        this.exportForm.controls["export_Type"].setValue("");
        let Selectedcheckboxes = this.exportForm.value
        formData.append('SelectedData', JSON.stringify(Selectedcheckboxes));

        const todayDate = new Date();
        const formattedDate = this.datepipe.transform(todayDate, 'yyyy-MM-dd HH:mm:ss');
        formData.append('FBI_StartTimeStamp', formattedDate ?? '');

        formData.append('APPeriodId', localStorage.getItem('currentPeriod') || '');
        formData.append('CompanyID', this.CharityDetails[0].charityID);

        // formData.append('UserID', this.CharityDetails[0].userId);
        const userId = parseInt(localStorage.getItem('userID') || '0', 10);
        formData.append('UserID', userId.toString());

        // Optional fields - pass empty string to avoid null binding issues
        formData.append('Actiontype', '');
        formData.append('AccountTemplateId', '123456'); // optional int
        formData.append('PackageReference', this.packageReference);
        formData.append('submissionDate', '');
        formData.append('DateSigned', '');

        // Optional fields not in original post, but required by model
        formData.append('version', '');
        formData.append('submissionstatus', '');
        formData.append('TransactionID', '');
        formData.append('Flag', '');
        formData.append('FBI_URLToUpload', '');
        formData.append('FBI_XMLToUpload', '');
        formData.append('FBIStatus', '');
        formData.append('FBI_Master_ID', '');
        formData.append('FBI_History_ID', '');
        formData.append('RequestType', '');
        formData.append('URL', '');
        formData.append('ResponseType', '');
        formData.append('ResponseTimeStamp', '');
        formData.append('ResponseText', '');
        formData.append('PeriodEnd', '');
        formData.append('FBI_History_JSON', '');
        formData.append('FBI_History_JSON_ResponseText', '');
        formData.append('CreatedBy', '');
        formData.append('TaxYear', localStorage.getItem("Current_AP_End_Date") ?? '');
        formData.append('FBIResponce', '');
        formData.append('APPeriodCoveredFrom', '');
        formData.append('CreatedDate', '');
        // Call API
        this.Submissionsapiservice.Submission(formData).subscribe(async (data) => {
          debugger
          this.ShowSpinner = false;
          this.enableNavigation()
          var parsedData = JSON.parse(data)
          //this.ShowFBI = true
          var Mix_XML_Response = JSON.parse(data);// data[0]
          Mix_XML_Response = Mix_XML_Response["xml"]
          var Mix_XML_Response_BreakUp = Mix_XML_Response.split('Break_Response')
          var HMRC_Response = Mix_XML_Response_BreakUp[0]

          this.FBI_XMLToUpload = Mix_XML_Response_BreakUp[0]
          //console.log(this.FBI_XMLToUpload);
          var FBI_XMLToUpload = Mix_XML_Response_BreakUp[0]
          var Original_XML = Mix_XML_Response_BreakUp[1]
          if (this.XML_Qualifier == "1")
            this.FBI_XMLData = Mix_XML_Response_BreakUp[1];

          this.CharityName = this.CharityDetails[0].charity_Name

          this.xml_result = HMRC_Response
          var parser1 = new DOMParser();
          var Original = parser1.parseFromString(Original_XML, "text/xml");
          //var FBI_XMLToUploadData = parser1.parseFromString(FBI_XMLToUpload, "text/xml");

          this.submissionNumber = Original.getElementsByTagName("SubmissionNumber")[0].childNodes[0].nodeValue;
          this.TransactionId = Original.getElementsByTagName("TransactionID")[0].childNodes[0].nodeValue;
          this.TransactionId = parsedData.objmodel.transactionID;
          this.LoginUserName = this.lsService.getCurrentUser?.userName
          //this.FbiStatus = FBI_XMLToUploadData.getElementsByTagName("StatusCode")[0]?.childNodes[0]?.nodeValue == 'ACCEPT' ? 'Accepted by CoHse ' : 'Pending CoHse response'
          this.SubmissionStatus = parsedData.objmodel.submissionstatus;
          this.CompanyHouseSubmissionStatus = parsedData.objmodel.companyHouseSubmissionStatus;

          if (this.SubmissionStatus === 'Success') {
            localStorage.setItem('SubmissionStatus', 'Success');
          } else if (this.SubmissionStatus === 'Failed') {
            localStorage.setItem('SubmissionStatus', 'Failed');
          }

          this.SubmissionId = parsedData.objmodel.submissionId;
          console.log(this.SubmissionDetails);
          if (this.CompanyHouseSubmissionStatus == 'pending') {
            this.CompanyHouseSubmissionStatus = 'Pending CoHse response';
          } else if (this.SubmissionDetails?.length > 0) {
            this.CompanyHouseSubmissionStatus = this.SubmissionDetails[0]?.companyHouseSubmissionStatus
          }

          localStorage.setItem('SubmissionId', parsedData.objmodel.submissionId)
          this.FBI_StartTimeStamp = parsedData.objmodel.fbI_StartTimeStamp;
          this.FBI_EndTimeStamp = parsedData.objmodel.fbI_EndTimeStamp;
          var parser = new DOMParser();
          var xmlDoc = parser.parseFromString(this.xml_result, "text/xml");

          //var Class = xmlDoc.getElementsByTagName("Class")[0]?.childNodes[0]?.nodeValue
          this.Qualifier = xmlDoc.getElementsByTagName("Qualifier")[0]?.childNodes[0]?.nodeValue;
          this.submissions_card = false;
          this.filing_details = false;
          this.submissionFBIpage = true;
          this.GetSubmissionDetails();
          ////Blob important
          //const htmlContent = atob(parsedData.base64); // Decode HTML
          //const newWindow = window.open();
          //newWindow?.document.write(htmlContent);
        });
      } else {
        return
      }
    });
  }
  backToCharityOverView() {
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);
  }
  handleInput(event: Event) {
    debugger
    const inputEl = event.target as HTMLInputElement;
    let value = inputEl.value;
    if (value.startsWith('e')) {
      value = 'E' + value.slice(1);
    }
    value = value[0] + value.slice(1).replace(/E/g, '');
    value = value[0] === 'E'
      ? 'E' + value.slice(1).replace(/[^0-9]/g, '')
      : value.replace(/[^0-9]/g, '');

    inputEl.value = value;
    this.SubmissionForm.controls['PresenterID'].setValue(inputEl.value);
  }
  clickPresenterID() {
    this.PresenterIDDoubleclickCount++;
  }

  clickPresenterEmailAddress() {
    this.PresenterEmailAddressDoubleclickCount++;
  }
  clickPresenterAuthenticationCode() {
    this.PresenterAuthenticationCodeDoubleclickCount++;
  }


  displayedColumns: string[] = ['dateandtime', 'requestsent', 'response'];
  fbiData: any[] = [
    { type: 'data', dateandtime: '15-10-2025 16:59', requestsent: '-', response: '-' },
  ];

  GetSubmissionCredentials() {
    debugger
    if (localStorage.getItem('currentCharityID') != null || localStorage.getItem('currentCharityID') != undefined || localStorage.getItem('currentCharityID') != '') {
      this.periodId = localStorage.getItem('currentPeriod')
      this.userId = localStorage.getItem('userID')
      this.centralUserId = localStorage.getItem('CentralUserId')
      this.charityId = localStorage.getItem('currentCharityID')
    }
    this._UsermanagementService.GetSubmissionCredentials(this.periodId, this.userId, this.centralUserId, this.charityId).subscribe((data: any) => {
      debugger
      if (data.entity != null) {
        if (data.entity[0].isCredentialsSaved) {
          this.SubmissionForm.controls['RegistrationNumber'].setValue(data.entity[0].companyRegistrationNumber)
          this.SubmissionForm.controls['CompanyAuthenticationCode'].setValue(data.entity[0].companyAuthenticationCode)
          this.SubmissionForm.controls['Submittedas'].setValue(data.entity[0].submitted_As)
          this.SubmissionForm.controls['PresenterContactName'].setValue(data.entity[0].presenterContactName == null || data.entity[0].presenterContactName == "null" ? '' : data.entity[0].presenterContactName)
          if (data.entity[0].submitted_As != 'Company') {
            if (this.SubmissionForm.controls['PresenterContactName'].value)
              this.SubmissionForm.controls['PresenterContactName'].disable();
            else
              this.SubmissionForm.controls['PresenterContactName'].enable();
          }

          this.SubmissionForm.controls['PresenterID'].setValue(data.entity[0].presenterID)
          if (data.entity[0].submitted_As != 'Company') {
            if (data.entity[0].presenterID)
              this.SubmissionForm.controls['PresenterID'].disable();
            else
              this.SubmissionForm.controls['PresenterID'].enable();
          }

          this.SubmissionForm.controls['PresenterAuthenticationCode'].setValue(data.entity[0].presenterAuthenticationCode)
          if (data.entity[0].submitted_As != 'Company') {
            if (data.entity[0].presenterAuthenticationCode)
              this.SubmissionForm.controls['PresenterAuthenticationCode'].disable();
            else {
              this.SubmissionForm.controls['PresenterAuthenticationCode'].enable();
            }
          }

          this.SubmissionForm.controls['PresenterEmailAddress'].setValue(data.entity[0].presenterEmailAddress)
          if (data.entity[0].submitted_As != 'Company') {
            if (data.entity[0].presenterEmailAddress) {
              this.SubmissionForm.controls['PresenterEmailAddress'].disable();
            } else {
              this.SubmissionForm.controls['PresenterEmailAddress'].enable();
            }

          }

          this.SubmissionForm.controls['PresenterContactNumber'].setValue(data.entity[0].presenterContactNumber == null || data.entity[0].presenterContactNumber == "null" ? '' : data.entity[0].presenterContactNumber)
          if (data.entity[0].submitted_As != 'Company') {
            if (this.SubmissionForm.controls['PresenterContactNumber'].value)
              this.SubmissionForm.controls['PresenterContactNumber'].disable();
            else
              this.SubmissionForm.controls['PresenterContactNumber'].enable();
          }

          //this.SubmissionForm.controls['SubmissionType'].setValue(data.entity[0].presenterEmailAddress)
          this.SubmissionForm.controls['SaveCredentials'].setValue(data.entity[0].isCredentialsSaved)
        }
        else {
          this.SubmissionForm.controls['RegistrationNumber'].setValue(this.CharityDetails[0].charity_Registration_Number)
          this.SubmissionForm.controls['RegistrationNumber'].disable();
        }
      }
    })
  }
  checkValue(controlName: any) {
    debugger
    if (controlName == 'CompanyAuthenticationCode') {
      if (this.SubmissionForm.controls['CompanyAuthenticationCode'].value?.length != 0 && this.SubmissionForm.controls['CompanyAuthenticationCode'].value?.length < 6) {
        this.SubmissionForm.controls['CompanyAuthenticationCode'].setErrors({ invalid: true })
      } else if (this.SubmissionForm.controls['CompanyAuthenticationCode'].value?.length == 0 || this.SubmissionForm.controls['CompanyAuthenticationCode'].value == null) {
        this.SubmissionForm.controls['CompanyAuthenticationCode'].setErrors({ required: true })
      }
      else {
        this.SubmissionForm.controls['CompanyAuthenticationCode'].setErrors(null);
      }
    }

    if (controlName == 'PresenterID') {
      if (this.SubmissionForm.controls['PresenterID'].value?.length == 0 || this.SubmissionForm.controls['PresenterID'].value == null) {
        this.SubmissionForm.controls['PresenterID'].setErrors({ required: true })
      }
      else {
        this.SubmissionForm.controls['PresenterID'].setErrors(null);
      }
    }

    if (controlName == 'PresenterContactNumber') {
      if (this.SubmissionForm.controls['PresenterContactNumber'].value?.length < 10 && this.SubmissionForm.controls['PresenterContactNumber'].value?.length != 0) {
        this.SubmissionForm.controls['PresenterContactNumber'].setErrors({ minLength: true })
      }
      else if (this.SubmissionForm.controls['PresenterContactNumber'].value?.length > 20) {

        this.SubmissionForm.controls['PresenterContactNumber'].setErrors({ maxLength: true });

      } else {
        this.SubmissionForm.controls['PresenterContactNumber'].setErrors(null);
      }
    }
  }
  fbiReceiptDownload(modal: any, id: any) {
    debugger
    this.ShowSpinner = true
    this.Submissionsapiservice.FBIReceipt(id).subscribe((data: any) => {
      debugger
      const byteCharacters = atob(data.toString());
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      var Downloadreportname = moment().format('YYYY MM DD HH mm ss') + '_' + localStorage.getItem('charity_Name') + ".pdf";
      this.dialog.open(modal, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        this.ShowSpinner = false
        if (this.pdfViewerAutoLoad) {
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();

        }
      }, 1000)
    })
  }
  fbiDownload(id: any) {
    debugger
    this.ShowSpinner = true;

    this.Submissionsapiservice.FBIReceipt(id).subscribe(
      (data: any) => {
        const byteCharacters = atob(data.toString());
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = moment().format('YYYYMMDDHHmmss') + '_' + localStorage.getItem('charity_Name') + ".pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        this.ShowSpinner = false;
      },
      (error) => {
        console.error('Error downloading FBI Receipt:', error);
        this.ShowSpinner = false;
      }
    );
  }
  downloadZip(id?: any, isView: any = false) {
    var filename = moment().format('YYYYMMDDHHmmss') + '_' + localStorage.getItem('charity_Name') + '.zip'
    if (isView) {
      const zip = new JSZip();
      const ts = moment().format('YYYYMMDDHHmmss');

      zip.file(`${ts}_submitresponse.xml`, this.xmlData);
      zip.file(`${ts}_submitrequest.xml`, this.xmlDataRequest);

      zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
        .then((content) => {
          const zipName = filename.endsWith('.zip') ? filename : `${filename}.zip`;
          saveAs(content, zipName);
        });
    }
    else {
      this.Submissionsapiservice.getXmldata(id).subscribe({
        next: (data: any) => {
          debugger
          this.xmlData = vkbeautify.xml(data.xmlResponse)
          this.xmlDataRequest = vkbeautify.xml(data.xmlRequest);
          // this.charityName = data.charityName;
          debugger

          const zip = new JSZip();
          const ts = moment().format('YYYYMMDDHHmmss');

          zip.file(`${ts}_submitresponse.xml`, this.xmlData);
          zip.file(`${ts}_submitrequest.xml`, this.xmlDataRequest);

          zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
            .then((content) => {
              const zipName = filename.endsWith('.zip') ? filename : `${filename}.zip`;
              saveAs(content, zipName);
            });
        },
        error: (err) => {
          console.error('Error fetching XML data:', err);
        }
      });
    }

  }
  openXmlDialog(id: any): void {
    debugger
    this.ShowSpinner = true
    this.Submissionsapiservice.getXmldata(id).subscribe({
      next: (data: any) => {
        debugger

        this.xmlData = vkbeautify.xml(data.xmlResponse)
        this.xmlDataRequest = vkbeautify.xml(data.xmlRequest);
        debugger
        this.dialog.open(this.xmlViewerTemplate, {
          width: '60vw',
          maxWidth: '960px',
          height: 'auto',
          disableClose: true,
          position: { top: '50px' },
          data: { xmlData: this.xmlData } // optional, if you want to pass via dialog data
        });
        this.ShowSpinner = false
      },
      error: (err) => {
        this.ShowSpinner = false
        console.error('Error fetching XML data:', err);
      }
    });
  }
  errorList: any = []
  openErrorLog(template: any, subid: any) {
    debugger
    this.Submissionsapiservice.getError(subid).subscribe((data: any) => {
      if (data != null) {
        this.SubmissionId = subid;
        this.errorList = data
      }
    })
    this.dialog.open(template, { width: '60%', disableClose: true, position: { top: '50px' } });
  }
  errorDownload(id: any) {
    debugger
    this.ShowSpinner = true;

    this.Submissionsapiservice.errorReport(id).subscribe(
      (data: any) => {
        const byteCharacters = atob(data.toString());
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'ErrorLog.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        this.ShowSpinner = false;
      },
      (error) => {
        console.error('Error downloading ErrorLog:', error);
        this.ShowSpinner = false;
      }
    );
  }

  openExport(templateExport: any) {
    debugger
    Object.keys(this.exportForm.controls).forEach(key => {
      this.exportForm.get(key)?.setValue(false);
    });
    const filteredControls = this.getFilteredControls();
    filteredControls.forEach(([_, control]) => {
      control.setValue(true);
    });

    if (this.report_Type === 'None') {
      this.exportForm.controls["independentExaminersReport"].setValue(false);
      this.exportForm.controls["auditorsReport"].setValue(false);
    }
    if (this.report_Type == 'Auditor') {
      this.exportForm.controls["trusteesAnnualReport"].disable()
      this.exportForm.controls["trusteesAnnualReport"].setValue(true);
    }
    else if (this.report_Type == 'Independent Examiner') {
      this.exportForm.controls["trusteesAnnualReport"].enable()
    }
    else if (this.report_Type == 'None')
    {
      this.exportForm.controls["independentExaminersReport"].setValue(false);
      this.exportForm.controls["independentExaminersReport"].disable();
      this.exportForm.controls["auditorsReport"].setValue(false);
      this.exportForm.controls["auditorsReport"].disable(); 
    }
    if (this.notecompleted) {
      this.exportForm.controls["notes"].disable()
      this.exportForm.controls["notes"].setValue(false);
    } else {
      this.exportForm.controls["notes"].enable()
      this.exportForm.controls["notes"].setValue(true);
    }
    let dialogRef = this.dialog.open(templateExport, {
      width: '40%', maxWidth: '100%', disableClose: true
    });
  }

  //isAnySectionSelected(): boolean {
  //  const excludedKeys = ['is_ForSubmissions', 'export_Type'];
  //  const coverAndContentKeys = ['coverPage', 'contentsPage']; // <-- adjust names to match your form control keys

  //  const formValues = this.exportForm.value;
  //  const selectedKeys = Object.entries(formValues)
  //    .filter(([key, value]) => !excludedKeys.includes(key) && value === true)
  //    .map(([key]) => key);
  //  if (selectedKeys.length === 0) {
  //    return false;
  //  }
  //  const onlyCoverContentSelected = selectedKeys.every(key =>
  //    coverAndContentKeys.includes(key)
  //  );

  //  return !onlyCoverContentSelected;
  //}
  isAnySectionSelected(): boolean {
    const values = this.exportForm.getRawValue();

    const excludedKeys = ['is_ForSubmissions', 'export_Type'];

    return Object.entries(values)
      .filter(([key]) => !excludedKeys.includes(key))
      .some(([_, value]) => value === true);
  }

  CreateCheckboxform() {
    this.exportForm = new FormGroup({
      coverPage: new FormControl(false),
      contentsPage: new FormControl(false),
      referenceandAdministrationDetails: new FormControl(false),
      trusteesAnnualReport: new FormControl(false),
      statementofTrusteesResponsibility: new FormControl(false),
      independentExaminersReport: new FormControl(false),
      auditorsReport: new FormControl(false),
      statementOfFinancialActivities: new FormControl(false),
      balanceSheet: new FormControl(false),
      notes: new FormControl(false),
      receiptsandPayments: new FormControl(false),
      statementofAssetsandLiabilities: new FormControl(false),
      is_ForSubmissions: new FormControl(false),  //important thing this will depend on submissions
      export_Type: new FormControl(null)
    });
  }
  getFilteredControls(): [string, AbstractControl][] {
    const enabledControls = Object.entries(this.exportForm.controls)
      .filter(([_, control]) => !control.disabled);

    let filteredControls: [string, AbstractControl][] = [];

    if (this.accounting_Method === 'Accruals (FRS 102 SORP)') {
      const baseExclusions = ['is_ForSubmissions', 'export_Type', 'receiptsandPayments', 'statementofAssetsandLiabilities'];
      if (this.TrusteeAnnualReportStatus !== 'Completed') {
        baseExclusions.push('trusteesAnnualReport');
      }
      if (this.StatementofTrusteesResponsibility !== 'Completed') {
        baseExclusions.push('statementofTrusteesResponsibility');
      }
      if (this.report_Type === 'Auditor') {
        baseExclusions.push('independentExaminersReport');
      }
      else if (this.report_Type === 'Independent Examiner') {
        baseExclusions.push('auditorsReport');
      }
      else if (this.report_Type === 'None') {
        baseExclusions.push(
          'independentExaminersReport',
          'auditorsReport'
        );
      }

      filteredControls = enabledControls.filter(([key]) => !baseExclusions.includes(key));

    } else {
      const baseExclusions = ['is_ForSubmissions', 'export_Type', 'statementOfFinancialActivities', 'balanceSheet'];

      if (this.TrusteeAnnualReportStatus !== 'Completed') {
        baseExclusions.push('trusteesAnnualReport');
      }

      if (this.StatementofTrusteesResponsibility !== 'Completed') {
        baseExclusions.push('statementofTrusteesResponsibility');
      }

      if (this.report_Type === 'Auditor') {
        baseExclusions.push('independentExaminersReport');
      } else {
        baseExclusions.push('auditorsReport');
      }

      filteredControls = enabledControls.filter(([key]) => !baseExclusions.includes(key));
    }

    return filteredControls;
  }

  GetFinalAccountsInfo() {
    debugger
    const period = localStorage.getItem('currentPeriod');
    this.disableNaviagtion()
    this.ShowSpinnerNote = true;
    this.apiservice.GetFinalNotes(period).subscribe((data: any) => {
      debugger
      if (data.finalAccounts.length || data.finalAccounts1.length || data.recordStatus.length) {
        this.ShowSpinnerNote = false;
        this.enableNavigation()
      }
      this.BalanceSheetStatus = data.finalAccounts.find((item: any) => item.accountName == 'Balance Sheet')?.accStatus
      this.TrailBalanceStatus = data.finalAccounts.find((item: any) => item.accountName == 'Trial Balance')?.accStatus
      this.SOFAStatus = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Financial Activities')?.accStatus
      this.ReceiptsStatus = data.finalAccounts.find((item: any) => item.accountName == 'Receipts and Payments')?.accStatus
      this.StatementStatus = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Assets and Liabilities')?.accStatus
      this.TrusteeAnnualReportStatus = data.finalAccounts.find((item: any) => item.accountName == 'Trustees Annual Report')?.accStatus
      this.AuditorStatus = data.finalAccounts.find((item: any) => item.accountName == 'Auditor')?.accStatus
      this.IndependentExaminationStatus = data.finalAccounts.find((item: any) => item.accountName == 'Independent Examination')?.accStatus
      if (this.IndependentExaminationStatus == 'Incompleted') {
        this.exportForm.controls["independentExaminersReport"].disable()
      } else {
        this.exportForm.controls["independentExaminersReport"].enable()
      }
      if (this.AuditorStatus == 'Incompleted') {
        this.exportForm.controls["auditorsReport"].disable()
      } else {
        this.exportForm.controls["auditorsReport"].enable()
      }
      if (this.SOFAStatus == 'Incompleted') {
        this.exportForm.controls["statementOfFinancialActivities"].disable()
      } else {
        this.exportForm.controls["statementOfFinancialActivities"].enable()
      }
      if (this.BalanceSheetStatus == 'Incompleted') {
        this.exportForm.controls["balanceSheet"].disable()
      } else {
        this.exportForm.controls["balanceSheet"].enable()
      }
      if (this.ReceiptsStatus == 'Incompleted') {
        this.exportForm.controls["receiptsandPayments"].disable()
      } else {
        this.exportForm.controls["receiptsandPayments"].enable()
      }
      if (this.StatementStatus == 'Incompleted') {
        this.exportForm.controls["statementofAssetsandLiabilities"].disable()
      } else {
        this.exportForm.controls["statementofAssetsandLiabilities"].enable()
      }
      this.StatementofTrusteesResponsibility = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Trustees’ Responsibility')?.accStatus
      if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
        if (localStorage.getItem('ReportType_Method') == 'Independent Examiner') {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Receipts and Payments',
                'Statement of Assets and Liabilities',
                'Independent Examination'
              ].includes(item.accountName)
            );
        }
        else {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Receipts and Payments',
                'Statement of Assets and Liabilities',
                'Auditor'
              ].includes(item.accountName)
            );
        }
      }
      else {
        if (localStorage.getItem('ReportType_Method') == 'Independent Examiner') {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Balance Sheet',
                'Statement of Financial Activities',
                'Independent Examination'
              ].includes(item.accountName)
            );
        }
        else {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Balance Sheet',
                'Statement of Financial Activities',
                'Auditor'
              ].includes(item.accountName)
            );
        }
      }
      this.progress = this.filteredAccounts?.length
      if (data.finalAccounts1 != null) {
        this.notesArray = data.finalAccounts1.filter((item: any) => item.accStatus == "Incompleted")
        this.notesArray = this.notesArray.sort((a: any, b: any) => {
          const numA = parseInt(a.note.replace(/\D/g, '')) || 0;
          const numB = parseInt(b.note.replace(/\D/g, '')) || 0;
          return numA - numB;
        });
        this.notecompleted = data.finalAccounts1.some((item: any) => item.accStatus == "Incompleted")
        if (!this.notecompleted) {
          this.progress += 1
        }
      }
      else {
        this.notecompleted = true
      }
      this.progress = this.progress == 0 ? 1 : this.progress
      if (data.recordStatus != null) {
        this.recordStatus = data.recordStatus
        if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
          if (this.recordStatus[0]?.accountName == 'ReceiptsAndPayments' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
            this.exportForm.get('receiptsandPayments')?.setValue(false);
            this.exportForm.get('receiptsandPayments')?.disable();


          }
          if (this.recordStatus[1]?.accountName == 'Statement_of_Assets_liabilities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
            this.exportForm.get('statementofAssetsandLiabilities')?.setValue(false);
            this.exportForm.get('statementofAssetsandLiabilities')?.disable();

          }
        }
        else {
          if (this.recordStatus[0]?.accountName == 'Balance Sheet' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
            this.exportForm.get('balanceSheet')?.setValue(false);
            this.exportForm.get('balanceSheet')?.disable();

          }
          if (this.recordStatus[1]?.accountName == 'Statement of Financial Activities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
            this.exportForm.get('statementOfFinancialActivities')?.setValue(false);
            this.exportForm.get('statementOfFinancialActivities')?.disable();

          }
        }
      }
    })
  }

  Getbasicinformation() {
    debugger
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    /*alert('hitted')*/
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.accounting_Method = data[0].accounting_Method
      this.report_Type = data[0].report_Type

    })
  }
  ShowSpinnerinside: any = false;
  ExportasPDFandIXBRL(ExportType?: any, Is_PDFviwer?: any, template?: any) {
    debugger
    var Period = this.PeriodDetils[0].current_AP_End_Date.slice(0, 10).split('-')
    var FileName = `${this.CharityDetails[0].charity_Name}_${Period[0]}${Period[1]}${Period[2]}`
    this.disableNaviagtion();
    this.ShowSpinnerinside = true;

    if (Is_PDFviwer == 'Spinnerthree') {
      this.ShowSpinner3 = true;
    } else {
      this.ShowSpinner3 = false;
    }
    if (Is_PDFviwer === 'ForPDFviwer') {
      if (this.notecompleted) {
        this.exportForm.controls["notes"].disable()
        this.exportForm.controls["notes"].setValue(false);
      } else {
        this.exportForm.controls["notes"].enable()
        this.exportForm.controls["notes"].setValue(true);
      }
      if (Is_PDFviwer === 'ForPDFviwer') {
        this.ShowSpinnerTwo = true;
      }
      const filteredControls = this.getFilteredControls();
      filteredControls.forEach(([_, control]) => {
        control.setValue(true);
      });
    }

    this.exportForm.controls["is_ForSubmissions"].setValue(false);
    this.exportForm.controls["export_Type"].setValue(ExportType);
    if (this.report_Type === 'None') {
      this.exportForm.patchValue({
        independentExaminersReport: false,
        auditorsReport: false
      });
    }
    let Selectedcheckboxes = this.exportForm.getRawValue()
    const formData: FormData = new FormData();
    formData.append('SelectedData', JSON.stringify(Selectedcheckboxes));
    formData.append('CompanyRegistrationNumber', this.CharityDetails[0].charity_Registration_Number);
    formData.append('CompanyName', this.CharityDetails[0].charity_Name);
    formData.append('APPeriodCoveredTo', '01/07/2024'); // date as string
    formData.append('ContactName', this.CharityDetails[0].first_Name_Detail);
    formData.append('ContactNumber', this.CharityDetails[0].telephone_Number);
    formData.append('CharityReferenceNumber', this.CharityDetails[0].company_Reference_Number);
    formData.append('jurisdiction_Charity', this.CharityDetails[0].jurisdiction_Charity);
    formData.append('ReportType', this.ReportType);

    formData.append('APPeriodId', localStorage.getItem('currentPeriod') || '');
    formData.append('CompanyID', this.CharityDetails[0].charityID);

    const userId = parseInt(localStorage.getItem('userID') || '0', 10);
    formData.append('UserID', userId.toString());
    formData.append('Actiontype', '');
    formData.append('AccountTemplateId', '123456'); // optional int
    formData.append('PackageReference', '');
    formData.append('submissionDate', '');
    formData.append('DateSigned', '');
    formData.append('version', '');
    formData.append('submissionstatus', '');
    formData.append('TransactionID', '');
    formData.append('Flag', '');
    formData.append('FBI_URLToUpload', '');
    formData.append('FBI_XMLToUpload', '');
    formData.append('FBIStatus', '');
    formData.append('SaveCredentials', '');
    formData.append('FBI_Master_ID', '');
    formData.append('FBI_History_ID', '');
    formData.append('RequestType', '');
    formData.append('URL', '');
    formData.append('ResponseType', '');
    formData.append('ResponseTimeStamp', '');
    formData.append('ResponseText', '');
    formData.append('PeriodEnd', '');
    formData.append('FBI_History_JSON', '');
    formData.append('FBI_History_JSON_ResponseText', '');
    formData.append('CreatedBy', '');
    formData.append('TaxYear', localStorage.getItem("Current_AP_End_Date") ?? '');
    formData.append('FBIResponce', '');
    formData.append('APPeriodCoveredFrom', '');
    formData.append('CreatedDate', '');
    this.Submissionsapiservice.GetSelectedReports(formData).subscribe(async (data) => {
      debugger
      if (data) {
        debugger
        this.ShowSpinnerinside = false;
        this.enableNavigation();
        var parsedData = JSON.parse(data)
        var Base64 = parsedData["base64string"]
        this.Base64orHTML = Base64.xmldata

        if (Is_PDFviwer == 'ForPDFviwer') {
          this.ShowSpinnerTwo = false;
          this.dialog.open(template, { width: '50%', maxWidth: '100%', disableClose: true }); //For opening PDFviewer         
          var htmlFile = 'data:application/pdf;base64,' + this.Base64orHTML
          this.Submissionsapiservice.downloadFile(htmlFile).subscribe(
            (res: any) => {
              setTimeout(() => {
                if (this.pdfViewerAutoLoad) {
                  this.pdfViewerAutoLoad.pdfSrc = res;
                  this.pdfViewerAutoLoad.downloadFileName = FileName;
                  this.pdfViewerAutoLoad.refresh();
                }
              }, 1000); //1000 milli seconds(1 sec)

            })
        } else {
          if (ExportType == 'ExportasPDF') {
            const byteCharacters = atob(this.Base64orHTML);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${FileName}.pdf`;
            link.click();
            window.URL.revokeObjectURL(link.href);
            // this.closeModalPreview()
          }
          else {
            this.ShowSpinner3 = false;
            var blob = new Blob([this.Base64orHTML], { type: "text/html" });
            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${FileName}.html`;
            link.click();
          }
        }
      }
    })
  }
}
export class CharityAccountArInformation {
  accounts_Qualified: boolean | null = null;
  centralUserId: number | null = null;
  charityID: number | null = null;
  createdDate: string | null = null;
  createdby: number | null = null;
  date_Due: string | null = null;
  date_Received: string | null = null;
  document_Name: string | null = null;
  financialPeriodsID: number | null = null;
  modifiedDate: string | null = null;
  modifiedby: number | null = null;
  reporting_Period_Year_End: string | null = null;
  suppression_Ind: boolean = false;
  suppression_Type: string | null = null;
  title: string | null = null;
  userId: number | null = null;
}
